import ChatSDK from 'test-iso-chat-sdk';

export const getConversationEligibleMembers = async ({conversationId, searchTag = null, limit=20, skip=0}) => {
    const params = {
        conversationId: conversationId,
        limit: limit,
        skip: skip
    };
    
    if (searchTag) {
        params.searchTag = searchTag;
    }
    
    const response = await ChatSDK.getInstance().Conversation.getConversationEligibleMembers(params);
    return response;
}


export const addConversationMember = async (conversationId, memberIds = []) => {
    const response = await ChatSDK.getInstance().Conversation.putMembers({
        conversationId: conversationId, 
        members: memberIds
    });
    return response;
}

export const removeConversationMember = async (conversationId, memberId) => {
    const response = await ChatSDK.getInstance().Conversation.deleteConversationMembers({
        conversationId: conversationId,
        members: memberId
    });
    return response;
}



